/**
 * The documents lab's way in: `/lab/office`, only for browsers where the lab flag is on (visit any page with
 * `?lab=1` once; `?lab=0` turns it off). Not linked from anywhere, not for customers. The lab is a chunk of its own.
 */

import type { FunctionComponent } from "preact";
import { lazy } from "../lib/lazy.ts";
import { store, stored } from "../lib/storage.ts";

export const LAB_KEY = "revisa.lab";
export const LAB_PATH = "/lab/office";

/** Whether the lab is on in this browser (`?lab=1` turns it on, `?lab=0` off). */
export function labEnabled(search: string): boolean {
  const flag = new URLSearchParams(search).get("lab");
  if (flag === "1" || flag === "0") {
    store(LAB_KEY, flag === "1" ? "1" : null);
  }
  return stored(LAB_KEY) === "1";
}

/** The lab's chunk (tests swap it). */
export const labChunk: { load: () => Promise<FunctionComponent> } = {
  load: lazy(() => import("./Lab.tsx").then((m) => m.Lab)),
};
